"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@cp-folder/success",
  ERROR: "@@cp-folder/error",
  RESET: "@@cp-folder/reset",
  RESET_PREVIEW: "@@cp-folder/reset-preview",
  CREATE: "@@cp-folder/create",
  GET_FOLDER: "@@cp-folder/get-folder",
  UPDATE_FOLDER: "@@cp-folder/update-folder",
  GET_ALL_FOLDER: "@@cp-folder/get-all-folder",
  GET_ALL_INITIAL_FOLDER: "@@cp-folder/get-all-initial-folder",
  GET_ALL_INITIAL_FOLDER_TEMPATE: "@@cp-folder/get-all-initial-folder-select-template",
  GET_ALL_INITIAL_FOLDER_CHANGE: "@@cp-folder/get-all-initial-folder-change",
  GET_ALL_CP_ROOT_NODE: "@@cp-folder/get-all-cproot-node",
  DELETE_CP_FOLDER: "@@cp-folder/delete-cpfolder",
  CP_DETAILS: "@@cp-folder/cp-details",
  CP_DETAILS_HTML: "@@cp-folder/cp-details-html",
  CP_PREVIEW_IMAGE: "@@cp-folder/cp-preview",
  CP_EDIT: "@@cp-folder/cp-edit"
};
//constant
exports.actionTypes = actionTypes;